<div class="content-wrapper">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section id="sample-page" *ngIf="!isViewMode">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body pb-1">
              <form #rastreadorForm="ngForm">
                <div class="card-body pb-1">
                  <!-- Fornecedor -->
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>Fornecedor</label>
                      <select [(ngModel)]="selectedFornecedor" name="fornecedor" class="form-control" required>
                        <option [ngValue]="null" disabled selected>Selecione uma opção</option>
                        <option *ngFor="let fornecedor of fornecedores" [value]="fornecedor.id_fornecedor">
                          {{ fornecedor.nome }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Fabricante -->
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>Fabricante</label>
                      <select [(ngModel)]="selectedFabricante" name="fabricante" class="form-control" required>
                        <option [ngValue]="null" disabled selected>Selecione uma opção</option>
                        <option *ngFor="let fabricante of fabricantes" [value]="fabricante.id_fabricante">
                          {{ fabricante.nome }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Despachante -->
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>Despachante</label>
                      <select [(ngModel)]="selectedDespachante" name="despachante" class="form-control" required>
                        <option [ngValue]="null" disabled selected>Selecione uma opção</option>
                        <option *ngFor="let despachante of despachantes" [value]="despachante.id_despachante">
                          {{ despachante.nome }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Modelo Rastreador -->
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>Modelo Rastreador</label>
                      <select [(ngModel)]="selectedModeloRastreador" name="modeloRastreador" class="form-control" required>
                        <option [ngValue]="null" disabled selected>Selecione uma opção</option>
                        <option *ngFor="let modelo of modelosRastreador" [value]="modelo.id_rastreador_modelo">
                          {{ modelo.nome }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Data de Compra -->
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>Data de Compra</label>
                      <input [(ngModel)]="dataCompra" name="dataCompra" type="text" class="form-control" required
                        mask="00/00/0000" [validation]="true" #dataCompraRef="ngModel"
                        placeholder="dd/mm/aaaa" />
                      <span *ngIf="dataCompraRef.invalid && rastreadorForm.submitted" class="invalid-form">
                        <small class="form-text text-danger" *ngIf="dataCompraRef.errors?.required">
                          Campo Obrigatório!
                        </small>
                        <small class="form-text text-danger" *ngIf="dataCompraRef.errors?.mask">
                          Data inválida!
                        </small>
                      </span>
                    </div>
                  </div>

                  <!-- Data de Chegada da Remessa -->
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label>Data de Chegada da Remessa</label>
                      <input [(ngModel)]="dataChegadaRemessa" name="dataChegadaRemessa" type="text" class="form-control" required
                        mask="00/00/0000" [validation]="true" #dataChegadaRemessaRef="ngModel"
                        placeholder="dd/mm/aaaa" />
                      <span *ngIf="dataChegadaRemessaRef.invalid && rastreadorForm.submitted" class="invalid-form">
                        <small class="form-text text-danger" *ngIf="dataChegadaRemessaRef.errors?.required">
                          Campo Obrigatório!
                        </small>
                        <small class="form-text text-danger" *ngIf="dataChegadaRemessaRef.errors?.mask">
                          Data inválida!
                        </small>
                      </span>
                    </div>
                  </div>

                  <!-- IMEIs dos Rastreadores -->
                  <div class="col-12">
                    <div class="form-group mb-2">
                      <label>IMEIs dos Rastreadores (separados por ENTER)</label>
                      <textarea [(ngModel)]="imeis" name="imeis" class="form-control" rows="5" required
                        placeholder="Insira os IMEIs, um por linha"></textarea>
                    </div>
                    <div class="mb-3">
                      <label class="btn btn-outline-primary">
                        Importar CSV
                        <input type="file" (change)="importCSV($event)" accept=".csv" hidden>
                      </label>
                      <small class="form-text text-muted ml-2">O arquivo CSV deve conter apenas IMEIs, separados por "," ou ";"</small>
                    </div>
                  </div>

                  <div class="col-12 mt-50">
                    <button routerLink="/rastreador" class="btn btn-secondary botao-cancelar"
                      rippleEffect>Cancelar</button>

                    <button (click)="submitForm(rastreadorForm)" type="submit"
                      class="btn btn-primary btn-next" rippleEffect
                      [disabled]="!rastreadorForm.form.valid">
                      <span class="align-middle d-sm-inline-block d-none">Salvar</span>
                      <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                    </button>
                    <br>
                    <br>
                    <div *ngIf="isLoading" class="spinner-border"></div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Hide all fields except the IMEI textarea -->
<div *ngIf="!isViewMode">
  <!-- Your existing form fields for create mode -->
</div>

<div *ngIf="isViewMode">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body pb-1">
          <!-- Display the information from the first object using inputs -->
          <div class="form-group">
            <label>Data de Compra</label>
            <input 
              type="text" 
              class="form-control" 
              [value]="dataCompra | date:'dd/MM/yyyy'" 
              readonly
            >
          </div>

          <div class="form-group">
            <label>Data de Chegada</label>
            <input 
              type="text" 
              class="form-control" 
              [value]="dataChegadaRemessa | date:'dd/MM/yyyy'" 
              readonly
            >
          </div>

          <div class="form-group">
            <label>Modelo do Rastreador</label>
            <input 
              type="text" 
              class="form-control" 
              [value]="selectedModeloRastreador" 
              readonly
            >
          </div>

          <div class="form-group">
            <label>Despachante</label>
            <input 
              type="text" 
              class="form-control" 
              [value]="selectedDespachante" 
              readonly
            >
          </div>

          <div class="form-group">
            <label>Fábrica</label>
            <input 
              type="text" 
              class="form-control" 
              [value]="selectedFabricante" 
              readonly
            >
          </div>

          <div class="form-group">
            <label>Fornecedor</label>
            <input 
              type="text" 
              class="form-control" 
              [value]="selectedFornecedor" 
              readonly
            >
          </div>

          <div class="form-group">
            <label for="imeis">IMEIs</label>
            <textarea 
              class="form-control" 
              id="imeis" 
              rows="10" 
              [(ngModel)]="imeis" 
              name="imeis" 
              readonly
            ></textarea>
          </div>

          <!-- Add Back Button -->
          <div class="form-group">
            <button 
              class="btn btn-secondary"
              (click)="onBack()"
            >
              Voltar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
